/**
 * Публичный URL витрины без завершающего слэша (канонический, OG, JSON-LD).
 * В проде задайте REACT_APP_SITE_URL=https://lutica.ru — иначе в браузере берётся window.location.origin.
 */
export function getPublicSiteUrl() {
    const fromEnv = (process.env.REACT_APP_SITE_URL || '').trim().replace(/\/+$/, '');
    if (fromEnv) {
        return fromEnv;
    }
    if (typeof window !== 'undefined' && window.location?.origin) {
        return String(window.location.origin).replace(/\/+$/, '');
    }
    return '';
}

/** Абсолютный URL страницы (путь с ведущим /). */
export function absolutePageUrl(pathname) {
    const base = getPublicSiteUrl();
    const path = pathname.startsWith('/') ? pathname : `/${pathname}`;
    return base ? `${base}${path}` : path;
}

/** Файл в public/ для превью в соцсетях (стабильный URL после сборки). */
export const PUBLIC_OG_IMAGE_PATH = '/lutica-logo-green.jpg';

/**
 * Абсолютный URL для og:image / twitter:image.
 * Приоритет: REACT_APP_SITE_OG_IMAGE → {SITE_URL}/lutica-logo-green.jpg из public/.
 */
export function resolveOgImageUrl() {
    const fromEnv = (process.env.REACT_APP_SITE_OG_IMAGE || '').trim();
    if (fromEnv) {
        return fromEnv;
    }
    const base = getPublicSiteUrl();
    return base ? `${base}${PUBLIC_OG_IMAGE_PATH}` : '';
}
